export const extractFamilyID = (href: string | undefined) =>
  href?.match(/(\d+)$/)?.[0];
